import React from 'react'
import { Button, Icon } from 'antd'

export const ShowButton = ({ open, total, action }) => (
    <Button 
        className={open ? "distributors__showbtn show" : "distributors__showbtn"} 
        onClick={action}
    >
        <span className="distributors__showbtn-left">
            <span>{!open ? "Показать список" : "Скрыть список"}</span>
            <Icon type="caret-down" />
        </span>
        <span className="distributors__showbtn-right">
            <span className="distributors__showbtn-part">Постановщика: </span>
            <span>{total}</span>
        </span>
    </Button>
)


// WEBPACK FOOTER //
// ./src/components/pages/projects/distributors/distributorsList/ShowButton.js